import { useContext } from 'react';
import { PageStandardContext } from 'components/modules/pagestandard/pagestandard';

export function useHideModal() {
  const context = useContext(PageStandardContext);
  return context.hideModal;
}
